<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row>
					<el-col :span="4">
						<el-form-item label="班级名称">
							<el-autocomplete class="inline-input" v-model="searchParams.name"
								:fetch-suggestions="querySearch" placeholder="请输入班级名称" 
								@select="handleSelect"></el-autocomplete>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-button type="primary" @click="search">搜索</el-button>
						<el-button @click="clearSearchVal">清空</el-button>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="dataTable autoFlex">
			<el-row>
				<el-col :span="24">
					<div id="rpt1" style="width:100%;height: 260px;"></div>
				</el-col>
				<el-col :span="10">
					<div id="rpt2" style="width:80%;height: 260px;top: 30px;"></div>
				</el-col>
			</el-row>
		</div>

	</div>
</template>
<script>

 
import api from '@/api/exams/exams/rpt_answers.js';
import apiClazz from '@/api/edu/clazz/clazz.js';

import * as echarts from 'echarts';

export default {
	name: 'exams',
	components: {
		echarts
	},
	data() {
		return {
			searchParams: {},
			listLoading: false,

			echart1: null,
			echartData1: {},

			clzList: null,  //备选班级

			echart2: null,
			echartData2: {} 

		};
	},

	methods: {
	    // 备选班级
		querySearch(queryString, cb) {
			if (this.clzList) {
				cb(this.clzList);
			}

		},
		// 选中班级
		handleSelect(item) {
			//console.log("选中班级",item)
			this.search()
		},


		//获取数据
		init() {
			 
			//初始化第一个报表
			this.echart1 = echarts.init(document.getElementById("rpt1"))
			this.echart2 = echarts.init(document.getElementById("rpt2"))

			//尝试前段缓存取   dftClzNm
			let dftClzNm  = this.$caches.dftClzNm.get(  "dftClzNm" );
			if(dftClzNm){
			 
				this.$set(this.searchParams,'name',dftClzNm)
				this.search()
			}

			
		     if (!this.clzList) {
			      //加载一个
			       apiClazz.listNoEnd(null, res => {
				 this.clzList = res.data
			    })

			}
		 
			 
		},


		search() {

			 this.$caches.dftClzNm.set(  this.searchParams.name );

			 api.getRpt1({clznm:this.searchParams.name},res=>{

                      // console.log("search()",res)
			    
			    let datas = res.data
                      let option1 ={
				title: {
                            text: this.searchParams.name+'班考试详情'
                        },
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				legend: {},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				xAxis: [
					{
						type: 'category',
						axisLabel: { interval: 0, rotate: 75 },
						data: []
					}
				],
				yAxis: [
					{
						type: 'value'
					}
				],
				series: [ 
				     {
						name: '未批改',
						type: 'bar',
						stack: 'Ad',
						emphasis: {
							focus: 'series'
						},
						data: []
					},
				     {
						name: '旷考',
						type: 'bar',
						stack: 'Ad',
						emphasis: {
							focus: 'series'
						},
						data: []
					},
					{
						name: '不及格',
						type: 'bar',
						stack: 'Ad',
						emphasis: {
							focus: 'series'
						},
						data: []
					},
					{
						name: '及格',
						type: 'bar',
						stack: 'Ad',
						emphasis: {
							focus: 'series'
						},
						data: []
					},
					{
						name: '良好',
						type: 'bar',
						stack: 'Ad',
						emphasis: {
							focus: 'series'
						},
						data: []
					},
					{
						name: '优秀',
						type: 'bar',
						stack: 'Ad',
						emphasis: {
							focus: 'series'
						},
						data: []
					}]
			};

                  let option2 ={
				title: {
					text: '考试成绩总览',
					subtext: this.searchParams.name,
					left: 'center'
				},
				tooltip: {
					trigger: 'item'
				},
				legend: {
					orient: 'vertical',
					left: 'right'
				},
				series: [
					{
						name: datas.length+'次考试',
						type: 'pie',
						radius: '55%',
						data: [
							{ value: 0, name: '未批改',label: { show: true, position: 'inside',formatter:'{c}' }},
							{ value: 0, name: '旷考' ,label: { show: true, position: 'inside',formatter:'{c}'  }},
							{ value: 0, name: '不及格',label: { show: true, position: 'inside',formatter:'{c}' }},
							{ value: 0, name: '及格' ,label: { show: true, position: 'inside' ,formatter:'{c}' }},
							{ value: 0, name: '良好',label: { show: true, position: 'inside',formatter:'{c}'   }},
							{ value: 0, name: '优秀' ,label: { show: true, position: 'inside' ,formatter:'{c}' }}
						],
						
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
				]
			  };


			//
			 
			datas.forEach(v=>{
				//柱状图
				option1.xAxis[0].data.push(v.ksday)
				option1.series[0].data.push(v.nogai)
				option1.series[1].data.push(v.nokao)
				option1.series[2].data.push(v.nopass)
				option1.series[3].data.push(v.pass)
				option1.series[4].data.push(v.good)
				option1.series[5].data.push(v.excs)

				//饼图
				option2.series[0].data[0].value+=v.nogai
				option2.series[0].data[1].value+=v.nokao
				option2.series[0].data[2].value+=v.nopass
				option2.series[0].data[3].value+=v.pass
				option2.series[0].data[4].value+=v.good
				option2.series[0].data[5].value+=v.excs
				 
			});

			 this.echart1.setOption(option1);
			 this.echart2.setOption(option2);

			 },err=>{
                        console.log(err)
			 })
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
			this.$caches.dftClzNm.remove( );
			this.init();
		}
	},
	mounted() {
		this.init();
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>

